import httpClient from "./httpClient";

export async function listCouponComments(couponPublicId, params = {}) {
  const { data } = await httpClient.get(
    `/coupons/${encodeURIComponent(couponPublicId)}/comments`,
    { params }
  );
  return data.comments || [];
}

export async function createCouponComment(couponPublicId, body) {
  const { data } = await httpClient.post(
    `/coupons/${encodeURIComponent(couponPublicId)}/comments`,
    body
  );
  return data;
}

export async function updateCouponComment(couponPublicId, commentId, body) {
  const { data } = await httpClient.put(
    `/coupons/${encodeURIComponent(couponPublicId)}/comments/${encodeURIComponent(commentId)}`,
    body
  );
  return data.comment;
}

export async function deleteCouponComment(couponPublicId, commentId) {
  const { data } = await httpClient.delete(
    `/coupons/${encodeURIComponent(couponPublicId)}/comments/${encodeURIComponent(commentId)}`
  );
  return data;
}
